export enum Gender {
  Male,
  Female,
  Transgender,
  NotSpecified
}
